import HNSColors from "../../../../ui library/HNSColors";

import { formatFeeScheduleCurrency } from "./helpers";

export default function FeeScheduleValueRow({
  title,
  amount,
  color,
  isActive = false,
  onMouseEnter,
  onMouseLeave,
  percentExists,
}) {
  const rowId = `fee-schedule-row-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

  return (
    <button
      id={rowId}
      type="button"
      disabled={!percentExists}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="flex w-full items-center justify-between gap-3 rounded-[8px] px-2 py-1.5 text-left outline-none transition-colors focus:outline-none"
      style={{ backgroundColor: isActive ? HNSColors.tertiary[975] : "transparent" }}
    >
      <div className="flex min-w-0 items-center gap-2">
        <span
          className="h-[10px] w-[10px] flex-none rounded-[3px]"
          style={{ backgroundColor: percentExists ? color : HNSColors.neutrals[975] }}
        />
        <span className="min-w-0 flex-none text-[13px]" style={{ color: HNSColors.neutrals[300] }}>
          {title}
        </span>
      </div>
      <span
        className="min-w-0 flex-1 truncate text-right text-[15px] font-semibold"
        style={{ color: HNSColors.neutrals[100] }}
      >
        {formatFeeScheduleCurrency(amount)}
      </span>
    </button>
  );
}
